//LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//HOOK
import { useGetProperties } from "../../hooks/useGetProperties";

//CONFIG
import appConfig from "../../config/appConfig";

//COMPONENTI
import LoadingIndicator from "../Loaders/LoadingIndicator";
import ImmobiliGrid from "../Properties/ImmobiliGrid";
import ImmobiliList from "../Properties/ImmobiliList";


const LastProperties: React.FC = () => {

    const { t } = useTranslation();
    const currentView = appConfig.ui.immobiliPage.defaultView;
    const ViewComponent = (currentView === 'list') ? ImmobiliList : ImmobiliGrid;

    // Ittieni utlimi ommobili inseriti
    const { properties, loading, error } = useGetProperties( appConfig.agency.id , { 
        offset: 0,
        limit: 3,
        withCount: false,
        filters: {
        },
        orderBy: {
            field: 'insertionDate',
            direction: 'desc',
        },
    })

    // ---- Gestione Stati Iniziali ----
    if (loading) return <LoadingIndicator />;

    if (error) {
        console.error("Errore caricamento Immobili:", error);
        return <div className="alert alert-warning">{t('common.loadingError', 'Errore caricamento dati.')}</div>;
    }

    if (!properties || properties.length === 0) {
        <div className="text-center p-5">{t('propertyList.notFound.title')}</div>;
    }

    return(
        <section className="space-ptb">
            <div className="container text-center">
                <h2 className="mb-5"> {t('homePage.lastPropertiesAdd.title')} </h2>
                <p className="mb-5" dangerouslySetInnerHTML={{ __html: t('homePage.lastPropertiesAdd.subTitle') as string }}></p>
            </div>
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <ViewComponent
                        properties={properties}
                        loading={loading}
                        error={null}
                        basePath="immobile"
                        labelSold={false}
                    />
                </div>
            </div>
            <div className="text-center mt-4">
                <Link to="/immobili" className="btn btn-primary" title={t('homePage.lastPropertiesAdd.btnTitle') as string}>
                    {t('homePage.lastPropertiesAdd.btnText')}
                </Link>
            </div>
        </section>
    )
};
export default LastProperties;